
<template>
    <div>
        <template v-if="add_topup_payment !== null && add_topup_payment!== false">
                <a  href="javascript:void(0)" @click="titlefetch(false)" class="btn btn-primary float-right" style="margin-left:5px" v-if="form.type == 'postpaid'"> Fetch Bill </a>

        <form @submit.prevent="uploadIndividualTopup">
			<div class="page-top mb-3 clearfix">
				<h1 class="float-left mt-2"> Topup Payments </h1>
				<button href="#" class="btn btn-primary float-right submitted process"  value="Submit" @click="uploadIndividualTopup"> Proceed </button> 
			</div>
			<div class="topup-payments-main">
				<div class="topup-payment-inner">
					<div class="form-group">
						<label class="label block-label"> Sim Type </label>
						<label class="radio-holder" ><input type="radio" placeholder="Sim Type"   value ="prepaid" id ="prepaid" v-model="form.type"     />Prepaid <span class="checkmark"></span></label>
						<label class="radio-holder"><input type="radio" placeholder="Sim Type"  value ="postpaid" id ="postpaid" v-model="form.type"      />Postpaid <span class="checkmark"></span></label>
						<has-error :form="form" field="type"></has-error>
					</div>
					<div class="form-group">
						<label class="label block-label">Name</label>
						<input type="text" placeholder="Name" class="form-control" v-model="form.name"   name="name" id="name" :class="{ 'is-invalid': form.errors.has('name')}"  />
						<has-error :form="form" field="name"></has-error>
					</div>
					<div class="form-group">
						<label class="label block-label"> Mobile Number </label>
						<input type="text" placeholder="Account Number" class="form-control" v-model="form.mobileNo" maxlength="12" onkeypress="return event.charCode >= 48 && event.charCode <= 57" name="mobileNo" id="mobileNo" :class="{ 'is-invalid': form.errors.has('mobileNo')}"  />
						<has-error :form="form" field="mobileNo"></has-error>
					</div>
					<div class="network-companies mb-4">
						<div class="icon-holder selected" id="zong" @click="addNetwork('zong')" >
							<img :src="$global.base_url+'images/network-company1.png'" alt=""/>
						</div>
						<div class="icon-holder" id="telenor" @click="addNetwork('telenor')">
							<img :src="$global.base_url+'images/network-company2.png'" alt="" />
						</div>
						<div class="icon-holder" id="ufone" @click="addNetwork('ufone')">
							<img :src="$global.base_url+'images/network-company3.png'" alt="" />
						</div>
						<div class="icon-holder" id="jazz" @click="addNetwork('jazz')">
							<img :src="$global.base_url+'images/network-company5.png'" alt="" />
						</div>
					</div>
					<div class="form-group">
						<label class="label block-label"> Amount <span style="float:right" v-if="form.type=='postpaid'">Due Amount: {{DueAmount}} </span> </label>
						<input type="text" class="form-control" value="250" v-model="form.amount" maxlength="12" onkeypress="return event.charCode >= 48 && event.charCode <= 57"  name="amount" id="amount" :class="{ 'is-invalid': form.errors.has('amount')}"  />
						<has-error :form="form" field="amount"></has-error>
					</div>
				</div>
			</div>
		</form>
        </template>
        <template v-else-if="add_topup_payment == null ">
         <preLoader></preLoader>
        </template>
        <template v-else-if="add_topup_payment == false">
          <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
	export default {
		data(){
				return{
				add_topup_payment:null,
				uploadButton:false,
				form: new Form({ 
					mobileNo:'',
					name:'',
					network:'',
					amount:0,
					type:'prepaid',
					payroll_id: this.$route.params.id
				}),
				DueAmount:0,
			}
		},
		mounted(){
			this.$Progress.start();
			this.can('add_topup_payment').then(result => {
				this.add_topup_payment = result.add_topup_payment;
			}).then(result =>{ 
				if(this.add_topup_payment == true){
					this.uploadButton=true;
				}
				this.form.network='zong';
			}).catch(err => {
				this.$Progress.fail();
			});
			this.$Progress.finish();
			EventBus.$on('uploadIndividualTopup', data => {
				if(data.code!==200 ){
					this.showAlertBox('error','Please fill the form carefully');
					$('.submitted').removeAttr('disabled');
			
					return false;
				}else{
						$('.process').prop('disabled',true);
					this.$Progress.start();
					this.form.post('/api/individualTopupUpload')
					.then(res => {
						if(res.data.code == 200){
							this.$Progress.finish();
							this.showToastBox('success','Batch created successfully');
							$('.process').prop('disabled',false);
							this.$router.push('/topupsPayments');
						}else{
							this.$Progress.fail();
							if(429 == res.data.code){
								this.showAlertBox('error',res.data.message);
								}else if(428 == res.data.code){
									this.showAlertBox('error',res.data.message);
								}else if(427 == res.data.code){
									this.showAlertBox('error',res.data.message);
								}else if(426 == res.data.code){
									this.showAlertBox('error',res.data.message);
								}else if(425 == res.data.code){
									this.showAlertBox('error',res.data.message);
								}else if(424 == res.data.code){
									this.showAlertBox('error',res.data.message);
								}else if(423 == res.data.code){
									this.showAlertBox('error',res.data.message);
								}else {
								this.showAlertBox('error','There is some problem');
								
								}
						
								$('.process').prop('disabled',false);
						}

					})
					.catch(err => {
						this.$Progress.fail();
						this.showAlertBox('error','There is some problem');
						$('.process').prop('disabled',false);
				
					});
				}
			});
		},
		methods: {
			addNetwork :function($req){
				this.form.network=$req;
			},
			titlefetch:function(check){
				if(this.form.mobileNo.length!==11 || this.form.mobileNo.substring(0,2)!=3){
					this.showAlertBox('error','Please enter valid mobile number');
					return false;
				} 
				// return {'code':200};
				var response='';
				$('.process').prop('disabled',true);
				this.$Progress.start();


				var data=this.form.post('/api/fetchbillTopup')
				.then(res => {

					if(res.data.code==200){
						if(check){
							return  EventBus.$emit('uploadIndividualTopup',res.data);
						}
						this.DueAmount=res.data.data.amountDue/100;
						this.form.amount=res.data.data.amountDue/100;
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Please recheck the provided information');
					}
					$('.process').prop('disabled',false);
				}).catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','There is some problem');
					$('.process').prop('disabled',false);
				});
			},
			uploadIndividualTopup: function(){
				if(this.form.amount<50){
					this.showAlertBox('error','Amount must be greater than 50');
					return false;
				}else if(this.form.mobileNo.length!==11 || this.form.mobileNo.substring(0,2)!=3){
					this.showAlertBox('error','Please enter valid mobile number');
					return false;
				}else if(this.form.name ==''){
					this.showAlertBox('error','Please enter name');
					return false;
				}
				this.titlefetch(true);
			},
		},
		updated(){
			$('.icon-holder').on('click', function(){
				$(this).addClass('selected');
				$(this).siblings().removeClass('selected');
			})
		},
		destroyed(){
			EventBus.$off('uploadIndividualTopup');
		}
	}

</script>